import { useCallback, useEffect, useState } from 'react'
import API from '../../../services/API'
import { normalizeVehicle, normalizeAsset } from './trackedItems'
import { getSeverityLevel } from '../makeReady/severity'

// Shared fetch+normalize for every vehicle/asset tracked by Make Ready, with
// full missing/expired/expiring item lists - used by the restock queue and
// the search/launch page so they can't drift on what a "tracked item" looks
// like. The board only needs counts and uses useMakeReadyBoard instead.
const useTrackedItems = () => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [trackedItems, setTrackedItems] = useState([])
  const [reloadKey, setReloadKey] = useState(0)

  const refresh = useCallback(() => setReloadKey((k) => k + 1), [])

  useEffect(() => {
    let active = true
    setLoading(true)
    setFetchError(false)

    Promise.all([
      API.get('/vehicleswithloadlists'),
      API.get('/assetswithloadlists'),
    ])
      .then(([vehiclesRes, assetsRes]) => {
        if (!active) return
        if (vehiclesRes.status !== 200 || assetsRes.status !== 200) {
          setFetchError(true)
          return
        }
        const vehicles = (vehiclesRes.data || []).map(normalizeVehicle)
        const assets = (assetsRes.data || []).map(normalizeAsset)
        setTrackedItems(
          [...vehicles, ...assets].map((item) => ({
            ...item,
            tracked: true,
            level: getSeverityLevel(item),
          })),
        )
      })
      .catch(() => {
        if (active) setFetchError(true)
      })
      .finally(() => {
        if (active) setLoading(false)
      })

    return () => {
      active = false
    }
  }, [reloadKey])

  return { trackedItems, setTrackedItems, loading, fetchError, refresh }
}

export default useTrackedItems
